import React, { useState } from 'react';
import { connect } from 'react-redux';

import { Container } from '../styles';
import { REGION } from '../enums';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import CheckboxControl from '../../../../Tracking/components/NFFilters/components/CheckboxControl';
import { regionEnumTransKey } from '../../../../Tracking/components/NFFilters/enums';

const label = Object.values(REGION);

const Regions = ({ isOpen, onClick, onApply, listRegion }) => {
  const [selectedItem, setSelectedItem] = useState(listRegion);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <FilterContainer label="Região" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por região"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={regionEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  listRegion: state.carbon.filters.listRegion,
});

export default connect(mapStateToProps)(Regions);
